<template>
    <div class="planos-container">
    <div class="back-button-top">
      <button class="back-link" @click="prevStep">Voltar</button>
    </div>
    <div class="logo-container">
      <img src="@/assets/img/logo.png" alt="LubConsulta" class="logo">
    </div>
    <div class="wizard narrow-wizard">
      <div class="step" :class="{ 'active': currentStep === 1 }">
        <div class="step-number">1</div>
        <div class="step-info">
          <div class="step-title">Selecione o plano</div>
          <div class="step-description">Selecione o melhor plano para o seu negócio.</div>
        </div>
      </div>
      <div class="step" :class="{ 'active': currentStep === 2 }">
        <div class="step-number">2</div>
        <div class="step-info">
          <div class="step-title">Pagamento</div>
          <div class="step-description">Preencha os dados de pagamento e selecione o tipo de cobrança.</div>
        </div>
      </div>
      <div class="step" :class="{ 'active': currentStep === 3 }">
        <div class="step-number">3</div>
        <div class="step-info">
          <div class="step-title">Assinatura</div>
          <div class="step-description">Parabéns, seu Plano foi registrado com sucesso.</div>
        </div>
      </div>
    </div>
    <div class="step-content narrow-content">
      <div v-if="currentStep === 1" class="step-1">
        <h2 class="narrow-title">Selecione o seu plano</h2>
        <p class="subtitle">Veja nossos plano e escolha a melhor opção para você e seu negocio.</p>

        <div class="plans-container">
          <!-- Card Plano Basic -->
          <div class="plan-card">
            <div class="plan-header">
              <h2>Plano Basic</h2>
            </div>
            <div class="plan-pricing">
              <div class="monthly">
                <div class="price">89,90</div>
                <div class="period">ou mês</div>
              </div>
              <div class="yearly">
                <div class="price">838,80</div>
                <div class="period">por ano em até 6x</div>
              </div>
              <div class="savings">Economize <strong>R$ 240,00</strong> no pagamento anual.</div>
            </div>
            <div class="plan-features">
              <div class="feature">
                      <svg xmlns="http://www.w3.org/2000/svg" class="icone-svg" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <circle cx="12" cy="12" r="10" fill="#53b42f" />
                        <path d="M9 12l2 2l4 -4" />
                      </svg>
                      Consulta de produtos pela placa do veículo
              </div>
              <div class="feature">
                      <svg xmlns="http://www.w3.org/2000/svg" class="icone-svg" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <circle cx="12" cy="12" r="10" fill="#53b42f" />
                        <path d="M9 12l2 2l4 -4" />
                      </svg> Consulta de veículos pelo modelo do veículo</div>
              <div class="feature">
                      <svg xmlns="http://www.w3.org/2000/svg" class="icone-svg" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <circle cx="12" cy="12" r="10" fill="#53b42f" />
                        <path d="M9 12l2 2l4 -4" />
                      </svg> Download do manual do propietário</div>
              <div class="feature">
                      <svg xmlns="http://www.w3.org/2000/svg" class="icone-svg" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <circle cx="12" cy="12" r="10" fill="#53b42f" />
                        <path d="M9 12l2 2l4 -4" />
                      </svg> Ficha técnica de lubrificantes</div>
              <div class="feature" style="color: #6f7170;">
                      <svg xmlns="http://www.w3.org/2000/svg" class="icone-svg" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <circle cx="12" cy="12" r="10" fill="#6f7170" />
                        <path d="M15 9l-6 6m0 -6l6 6" />
                      </svg> Cadastro de clientes</div>
              <div class="feature" style="color: #6f7170;">
                      <svg xmlns="http://www.w3.org/2000/svg" class="icone-svg" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <circle cx="12" cy="12" r="10" fill="#6f7170" />
                        <path d="M15 9l-6 6m0 -6l6 6" />
                      </svg> Registro de serviço de troca de óleo</div>
              <div class="feature" style="color: #6f7170;">
                      <svg xmlns="http://www.w3.org/2000/svg" class="icone-svg" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <circle cx="12" cy="12" r="10" fill="#6f7170" />
                        <path d="M15 9l-6 6m0 -6l6 6" />
                      </svg> Lembrete automático via WhatsApp para a próxima troca de óleo do veículo</div>
            </div>
            <button class="select-button" @click="selectPlan('basic')">SELECIONAR</button>
          </div>

          <!-- Card Plano Plus -->
          <div class="plan-card plus">
            <div class="plan-header">
              <h2>Plano Plus</h2>
            </div>
            <div class="plan-pricing">
              <div class="monthly">
                <div class="price">179,90</div>
                <div class="period">ou mês</div>
              </div>
              <div class="yearly">
                <div class="price">1558,80</div>
                <div class="period">por ano em até 6x</div>
              </div>
              <div class="savings2">Economize <strong>R$ 600,00</strong> no pagamento anual.</div>
            </div>
            <div class="plan-features">
              <div class="feature">
                      <svg xmlns="http://www.w3.org/2000/svg" class="icone-svg" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <circle cx="12" cy="12" r="10" fill="#53b42f" />
                        <path d="M9 12l2 2l4 -4" />
                      </svg> Catálogo completo de lubrificantes e filtros</div>
              <div class="feature">
                      <svg xmlns="http://www.w3.org/2000/svg" class="icone-svg" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <circle cx="12" cy="12" r="10" fill="#53b42f" />
                        <path d="M9 12l2 2l4 -4" />
                      </svg> Consulta de produtos pela placa do veículo</div>
              <div class="feature">
                      <svg xmlns="http://www.w3.org/2000/svg" class="icone-svg" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <circle cx="12" cy="12" r="10" fill="#53b42f" />
                        <path d="M9 12l2 2l4 -4" />
                      </svg> Consulta de veículos pelo modelo do veículo</div>
              <div class="feature">
                      <svg xmlns="http://www.w3.org/2000/svg" class="icone-svg" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <circle cx="12" cy="12" r="10" fill="#53b42f" />
                        <path d="M9 12l2 2l4 -4" />
                      </svg> Download do manual do propietário</div>
              <div class="feature">
                      <svg xmlns="http://www.w3.org/2000/svg" class="icone-svg" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <circle cx="12" cy="12" r="10" fill="#53b42f" />
                        <path d="M9 12l2 2l4 -4" />
                      </svg> Ficha técnica de lubrificantes</div>
              <div class="feature">
                      <svg xmlns="http://www.w3.org/2000/svg" class="icone-svg" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <circle cx="12" cy="12" r="10" fill="#53b42f" />
                        <path d="M9 12l2 2l4 -4" />
                      </svg> Cadastro de clientes</div>
              <div class="feature">
                      <svg xmlns="http://www.w3.org/2000/svg" class="icone-svg" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <circle cx="12" cy="12" r="10" fill="#53b42f" />
                        <path d="M9 12l2 2l4 -4" />
                      </svg> Registro de serviço de troca de óleo</div>
              <div class="feature">
                      <svg xmlns="http://www.w3.org/2000/svg" class="icone-svg" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <circle cx="12" cy="12" r="10" fill="#53b42f" />
                        <path d="M9 12l2 2l4 -4" />
                      </svg> Lembrete automático via WhatsApp para a próxima troca de óleo do veículo</div>
            </div>
            <button class="select-button" @click="selectPlan('plus')">SELECIONAR</button>
          </div>
        </div>
      </div>

      <div v-if="currentStep === 2" class="step-2">
        <h2 class="narrow-title">Escolha a forma de pagamento</h2>
        <p class="subtitle">Selecione a forma de pagamento e preencha com os dados solicitados</p>
        <div class="plan-card2" style="border: 1px solid #f4a954; border-radius: 8px; padding: 10px;">                  
          <div class="plan-sub" style="font-weight: bold; text-align: left;">VOCÊ SELECIONOU O PLANO</div>
          <div class="plan-name" style="background-color: #ef8d1e; color: white; font-size: 24px; font-weight: bold; border-radius: 5px; padding: 8px; width: 250px; margin-bottom: 5px;">
            {{ selectedPlan === 'basic' ? 'Plano Basic' : 'Plano Plus' }}
          </div>
          <div class="plan-value" style="margin-bottom: 10px; padding: 10px;">
          <p><strong>VALOR</strong></p>
            <div class="plan-price" style="font-weight: bold; font-size: 20px;  color:rgb(133, 131, 131);">
              <strong v-if="selectedPlan === 'basic'">R$ 89,90</strong>
              <strong v-if="selectedPlan === 'plus'">R$ 179,90</strong> mensal ou 
              <strong v-if="selectedPlan === 'basic'">R$ 838,80</strong>
              <strong v-if="selectedPlan === 'plus'">R$ 1.558,80</strong> anual em até 6x
            </div>
          </div>

          <div class="collapse-item" style="margin: 5px 0;">
            <div class="collapse-header" @click="toggleCoupon" style="cursor: pointer;">
              <IconCirclePercentageFilled stroke={2} style="display: inline-block; vertical-align: middle; color: #3E8DDD; margin-right: 8px;" />  
              <strong>ADICIONAR CUPOM DE DESCONTO</strong>
              <span class="collapse-icon" :class="{ expanded: showCoupon }">▼</span>
            </div>
            <div v-if="showCoupon" class="collapse-content" style="margin-top: 5px;">
              <div class="coupon-input">
                <div class="form-group">
                  <label class="form-label">Código do cupom</label>
                  <input 
                    type="text" 
                    class="form-input" 
                    v-model="coupon.code" 
                    placeholder="Digite o código do cupom"
                  >
                  <div class="hint-message" v-if="couponHint">{{ couponHint }}</div>
                </div>
                <button class="btn btn-outline" @click="validateCoupon">Validar Cupom</button>
              </div>
            </div>
          </div>

          <div class="collapse-item" style="margin: 5px 0;">
            <div class="collapse-header" @click="togglePlanDetails" style="cursor: pointer;">
              <IconArrowBigRightFilled stroke={2} style="display: inline-block; vertical-align: middle; color: #3E8DDD; margin-right: 8px;" />   
              <strong>Ver detalhes do plano</strong>
              <span class="collapse-icon" :class="{ expanded: showPlanDetails }">▼</span>
            </div>
            <div v-if="showPlanDetails" class="collapse-content" style="margin-top: 5px;">
              
              <div v-if="selectedPlan === 'plus'">
                  <p><strong>O que o plano oferece:</strong></p>
                  <ul style="margin-left: 20px; margin-top: 10px;">
                      <li>Catálogo completo de lubrificantes e filtros</li>
                      <li>Consulta de produtos pela placa do veículo</li>
                      <li>Consulta de veículos pelo modelo do veículo</li>
                      <li>Download do manual do propietário</li>
                      <li>Ficha técnica de lubrificantes</li>
                      <li>Cadastro de clientes</li>
                      <li>Registro de serviço de troca de óleo</li>
                      <li>Lembrete automático via WhatsApp para a próxima troca de óleo do veículo</li>
                  </ul>
              </div>

              <div v-else-if="selectedPlan === 'basic'">
                  <p><strong>O que o plano oferece:</strong></p>
                  <ul style="margin-left: 20px; margin-top: 10px;">
                      <li>Consulta de produtos pela placa do veículo</li>
                      <li>Consulta de veículos pelo modelo do veículo</li>
                      <li>Download do manual do propietário</li>
                      <li>Ficha técnica de lubrificantes</li>
                  </ul>
              </div>
            </div>
          </div>

        </div>

        <div class="form-section">
          <h2 class="form-title">Dados do Cliente</h2>
          
          <div class="form-row">
            <div class="form-group">
              <label class="form-label">CNPJ <span class="required">*</span></label>
              <input 
                type="text" 
                class="form-input" 
                v-model="personalInfo.document" 
                placeholder="00.000.000/0000-00"
                @input="onCnpjInput"
                @blur="fetchAndPopulateCustomerData" 
                @keydown.enter.prevent="handleCnpjNavigation"
                @keydown.tab.prevent="handleCnpjNavigation">
            </div>

            <!-- Nome Completo -->
            <div class="form-group">
              <label class="form-label">Nome completo <span class="required">*</span></label>
              <input type="text" class="form-input" v-model="personalInfo.fullName"
                  :disabled="fieldStates.fullName"
                  :class="{ 'disabled-field': fieldStates.fullName }"
                  placeholder="Digite seu nome completo">
            </div>
          </div>
          
          <div class="form-row">
            <div class="form-group">
              <label class="form-label">Telefone <span class="required">*</span></label>
              <input
                ref="phoneInput"
                type="text"
                class="form-input"
                :class="{ 'input-invalid': validation.phoneTouched && !personalInfo.phone }"
                v-model="personalInfo.phone"
                :placeholder="phonePlaceholder"
                @input="onPhoneInput"
                @blur="validatePhoneField"
              >
            </div>

            <!-- E-mail -->
            <div class="form-group">
              <label class="form-label">E-mail <span class="required">*</span></label>
              <input
                ref="emailInput"
                type="email"
                class="form-input"
                :class="{ 'input-invalid': validation.emailTouched && !personalInfo.email }"
                v-model="personalInfo.email"
                :placeholder="emailPlaceholder"
                @input="checkEmailPattern"
                @blur="triggerContactModal"
              >
            </div>
          </div>
            
          <div class="form-row">
            <div class="form-group">
              <label class="form-label">Endereço <span class="required">*</span></label>
              <input type="text" class="form-input" v-model="billingAddress.street"
                :disabled="fieldStates.street"
                  :class="{ 'disabled-field': fieldStates }"
                  placeholder="Rua Rui Barbosa"
                @blur="fetchAndPopulateCustomerData" @keydown.enter.prevent="fetchAndPopulateCustomerData">
            </div>

            <div class="form-group">
              <label class="form-label">CEP <span class="required">*</span></label>
              <input type="text" class="form-input" v-model="billingAddress.zipCode"
                :disabled="fieldStates.zipCode"
                  :class="{ 'disabled-field': fieldStates }"
                  placeholder="60400-160"
                @blur="fetchAndPopulateCustomerData" @keydown.enter.prevent="fetchAndPopulateCustomerData">
            </div>
          </div>

          <div class="form-row">
            <div class="form-group">
              <label class="form-label">Número <span class="required">*</span></label>
              <input type="text" class="form-input" v-model="billingAddress.number"
                :disabled="fieldStates.number"
                  :class="{ 'disabled-field': fieldStates }"
                  placeholder="1050"
                @blur="fetchAndPopulateCustomerData" @keydown.enter.prevent="fetchAndPopulateCustomerData">
            </div>
            <div class="form-group">
              <label class="form-label">Bairro</label>
              <input type="text" class="form-input" v-model="billingAddress.bairro"
                :disabled="fieldStates.bairro"
                  :class="{ 'disabled-field': fieldStates }"
                  placeholder="Digite o bairro"
                @blur="fetchAndPopulateCustomerData" @keydown.enter.prevent="fetchAndPopulateCustomerData">
            </div>
            <div class="form-group">
              <label class="form-label">Complemento</label>
              <input type="text" class="form-input" v-model="billingAddress.complement"
                :disabled="fieldStates.complement"
                  :class="{ 'disabled-field': fieldStates }"
                  placeholder="Digite o complemento"
                @blur="fetchAndPopulateCustomerData" @keydown.enter.prevent="fetchAndPopulateCustomerData">
            </div>
          </div>

          <div class="form-row">
            <div class="form-group">
              <label class="form-label">País</label>
              <input type="text" class="form-input" v-model="billingAddress.country"
                :disabled="fieldStates.country"
                  :class="{ 'disabled-field': fieldStates }"
                  placeholder="Brasil"
                @blur="fetchAndPopulateCustomerData" @keydown.enter.prevent="fetchAndPopulateCustomerData">
            </div>
            <div class="form-group">
              <label class="form-label">UF <span class="required">*</span></label>
              <input type="text" class="form-input" v-model="billingAddress.state"
                :disabled="fieldStates.state"
                  :class="{ 'disabled-field': fieldStates }"
                  placeholder="UF"
                @blur="fetchAndPopulateCustomerData" @keydown.enter.prevent="fetchAndPopulateCustomerData">
            </div>
            <div class="form-group">
              <label class="form-label">Cidade <span class="required">*</span></label>
              <input type="text" class="form-input" v-model="billingAddress.city"
                :disabled="fieldStates.city"
                  :class="{ 'disabled-field': fieldStates }"
                  placeholder="Digite a Cidade"
                @blur="fetchAndPopulateCustomerData" @keydown.enter.prevent="fetchAndPopulateCustomerData">
            </div>
          </div>
        </div>


        <div class="form-section">
          <h2 class="form-title">Forma de pagamento</h2>
          <div class="payment-methods">
            <div class="payment-method" :class="{ active: paymentMethod === 'creditCard' }" @click="paymentMethod = 'creditCard'">
              <strong style="display: inline-block;">Cartão de Crédito</strong> 
              <IconCreditCardFilled stroke={2} style="display: inline-block; vertical-align: middle;" />
            </div>
            <div class="payment-method" :class="{ active: paymentMethod === 'boleto' }" @click="paymentMethod = 'boleto'; valorSelecionado = ''">
              <strong style="display: inline-block;">Boleto</strong> 
              <IconBarcode :stroke="2" style="display: inline-block; vertical-align: middle;" />
            </div>
            <div class="payment-method" :class="{ active: paymentMethod === 'pix' }" @click="paymentMethod = 'pix'; valorSelecionado = ''">
              <strong style="display: inline-block;">Pix</strong> 
              <IconQrcode stroke={2} style="display: inline-block; vertical-align: middle;" />
            </div>
          </div>

          <!-- Formulário Cartão de Crédito -->
          <div v-if="paymentMethod === 'creditCard'">
            <div class="valor-cobranca" style="margin-bottom: 20px; text-align: left;">
                <label style="font-weight: bold; margin-bottom: 8px; display: block;">Valor <span style="color: red;">*</span></label>
                <select
                    v-model="valorSelecionado"
                    class="form-control"
                    style="width: 100%; padding: 10px; border-radius: 25px; border: 1px solid #ccc;"
                    @change="handlePaymentOptionChange"
                >
                    <option value="">Selecione um plano</option>

                    <!-- Opções para Plano Plus -->
                    <option v-if="selectedPlan === 'plus'" value="179.90">R$ 179,90 mensal</option>
                    <option v-if="selectedPlan === 'plus'" value="1558.80">R$ 1.558,80 anual (com desconto)</option>
                    <option v-if="selectedPlan === 'plus'" value="1558.82">Em 2x de R$ 779,40 sem juros</option>
                    <option v-if="selectedPlan === 'plus'" value="1558.83">Em 3x de R$ 519,60 sem juros</option>
                    <option v-if="selectedPlan === 'plus'" value="1558.84">Em 4x de R$ 389,70 sem juros</option>
                    <option v-if="selectedPlan === 'plus'" value="1558.85">Em 5x de R$ 311,76 sem juros</option>
                    <option v-if="selectedPlan === 'plus'" value="1558.86">Em 6x de R$ 259,80 sem juros</option>
                    <!-- <option v-if="selectedPlan === 'plus'" value="10.00">Em 2x de R$ 5,00 sem juros</option> -->

                    <!-- Opções para Plano Basic -->
                    <option v-if="selectedPlan === 'basic'" value="89.90">R$ 89,90 mensal</option>
                    <option v-if="selectedPlan === 'basic'" value="838.81">R$ 838,80 anual (com desconto)</option>
                    <option v-if="selectedPlan === 'basic'" value="838.82">Em 2x de R$ 419,40 sem juros</option>
                    <option v-if="selectedPlan === 'basic'" value="838.83">Em 3x de R$ 279,60 sem juros</option>
                    <option v-if="selectedPlan === 'basic'" value="838.84">Em 4x de R$ 209,70 sem juros</option>
                    <option v-if="selectedPlan === 'basic'" value="838.85">Em 5x de R$ 167,76 sem juros</option>
                    <option v-if="selectedPlan === 'basic'" value="838.86">Em 6x de R$ 139,80 sem juros</option>
                </select>
            </div>
            
            <div class="form-row">
                <div class="form-group">
                <label class="form-label">Número do cartão <span class="required">*</span></label>
                <input type="text" class="form-input" v-model="creditCard.number" placeholder="0000 0000 0000 0000">
                </div>
                <div class="form-group">
                <label class="form-label">Nome do titular <span class="required">*</span></label>
                <input type="text" class="form-input" v-model="creditCard.holderName" placeholder="Nome como está no cartão">
                </div>
            </div>
            <div class="form-row">
                <div class="form-group" style="flex: 0 0 150px;">
                <label class="form-label">Validade <span class="required">*</span></label>
                <input type="text" class="form-input" v-model="creditCard.expiryDate" placeholder="MM/AA">
                </div>
                <div class="form-group" style="flex: 0 0 100px;">
                <label class="form-label">CVV <span class="required">*</span></label>
                <input type="text" class="form-input" v-model="creditCard.cvv" placeholder="000">
                </div>
                <!-- NOVO: Div para exibir o valor final -->
                <div v-if="valorSelecionado" class="form-group" style="flex: 1; margin-left: 20px;">
                    <label class="form-label">Valor Final:</label>
                    <div style="font-weight: bold; font-size: 1.2em; padding-top: 5px;">
                        {{ valorFinalFormatado }}
                    </div>
                </div>
            </div>
          </div>
        </div>

        <!-- Formulário Boleto -->
        <div v-if="paymentMethod === 'boleto'" class="boleto-display">
          <div class="info-alert" style="background: #e0e0e0; padding: 10px; border-radius: 6px; margin-bottom: 20px; text-align: left;">
            <span style="color: #333;">
              <IconInfoCircleFilled stroke={2} style="display: inline-block; vertical-align: middle; color: #3E8DDD;" /> 
              <strong style="display: inline-block;"> O boleto será enviado para o e-mail cadastrado.</strong>
            </span>
          </div>
          <div class="billing-options" style="margin-bottom: 20px; text-align: left;">
            <label style="font-weight: bold;">Cobrança Mensal ou Anual <span style="color: red;">*</span></label>
            <div style="margin: 8px 0;">
              <span style="background-color: #f7931e; color: #000000; padding: 6px 10px; border-radius: 6px; font-weight: bold; display: inline-block; vertical-align: middle;">
              <IconCirclePercentageFilled stroke={2} style="display: inline-block; vertical-align: middle; color: #000000;" /> Economize 10% no plano anual.
              </span>
            </div>
          </div>
          <div style="margin-bottom: 20px; text-align: left;">
            <label style="font-weight: bold; color: #6f7170;">Método de pagamento:</label>
            <p>
              Você optou por <strong>boleto bancário</strong>. Mensalmente, enviaremos o boleto correspondente ao período para o seu e-mail, facilitando o seu pagamento.
            </p>
          </div>
          <div class="valor-cobranca" style="margin-bottom: 20px; text-align: left;">
            <label style="font-weight: bold; margin-bottom: 8px; display: block;">Valor <span style="color: red;">*</span></label>
            
            <!-- Select para Plano Plus -->
            <select
              v-if="selectedPlan === 'plus'"
              v-model="valorSelecionado"
              class="form-control"
              style="width: 100%; padding: 10px; border-radius: 25px; border: 1px solid #ccc;"
              @change="handlePaymentOptionChange" 
            >
              <option value="">Selecione um plano</option>
              <option value="179.90">R$ 179,90 mensal</option>
              <option value="1558.80">R$ 1.558,80 anual (com desconto)</option>
            </select>

            <!-- Select para Plano Basic -->
            <select
              v-if="selectedPlan === 'basic'"
              v-model="valorSelecionado"
              class="form-control"
              style="width: 100%; padding: 10px; border-radius: 25px; border: 1px solid #ccc;"
              @change="handlePaymentOptionChange"
            >
              <option value="">Selecione um plano</option>
              <option value="89.90">R$ 89,90 mensal</option>
              <option value="838.80">R$ 838,80 anual (com desconto)</option>
            </select>

          </div>
          <div v-show="showBoleto" class="boleto-container">
            <h3>BOLETO BANCÁRIO</h3>
              <div class="linha-digitavel">
                {{ linhaDigitavel }}
              </div>

              <div class="boleto-box">
                <!-- Header -->
                <div class="linha">
                  <div class="col logo">
                    <img src="@/assets/img/logo.png" alt="LubConsulta" class="logo">
                  </div>
                  <div class="col numero">461</div>
                  <div class="col linha-digitavel-right">E-Mail: contato@lubconsulta.com.br</div>
                </div>

                <div class="linha">
                  <div class="col grande">
                    <div class="rotulo">Local de pagamento</div>
                    <div>Pagável em qualquer banco ou casa lotérica</div>
                  </div>
                  <div class="col pequeno">
                    <div class="rotulo">Vencimento</div>
                    <div>{{ dados.vencimento }}</div>
                  </div>
                </div>

                <div class="linha">
                  <div class="col grande">
                    <div class="rotulo">Beneficiário</div>
                    <div>{{ dados.beneficiario }} - {{ dados.cnpjBeneficiario }}</div>
                  </div>
                  <div class="col pequeno">
                    <div class="rotulo">Agência / Código beneficiário</div>
                    <div>0001 / 6141717-3</div>
                  </div>
                </div>

                <div class="linha">
                  <div class="col pequeno">
                    <div class="rotulo">Data do documento</div>
                    <div>{{ dados.dtcria }}</div>
                  </div>
                  <div class="col pequeno">
                    <div class="rotulo">Número do documento</div>
                    <div>{{ dados.numDoc }}</div>
                  </div>
                  <div class="col pequeno">
                    <div class="rotulo">Espécie doc.</div>
                    <div>DM</div>
                  </div>
                  <div class="col pequeno">
                    <div class="rotulo">Aceite</div>
                    <div>{{ dados.status }}</div>
                  </div>
                  <div class="col pequeno">
                    <div class="rotulo">Data de processamento</div>
                    <div>{{ dados.dtcria }}</div>
                  </div>
                  <div class="col pequeno">
                    <div class="rotulo">Nosso número</div>
                    <div>{{ dados.nossoNumero }}</div>
                  </div>
                </div>

                <div class="linha">
                  <div class="col pequeno">
                    <div class="rotulo">Uso do banco</div>
                    <div>1</div>
                  </div>
                  <div class="col pequeno">
                    <div class="rotulo">Carteira</div>
                    <div>1</div>
                  </div>
                  <div class="col pequeno">
                    <div class="rotulo">Espécie</div>
                    <div>REAL</div>
                  </div>
                  <div class="col pequeno">
                    <div class="rotulo">Quantidade</div>
                    <div>-</div>
                  </div>
                  <div class="col pequeno">
                    <div class="rotulo">Valor</div>
                    <div>R$ {{ dados.valor }}</div>
                  </div>
                  <div class="col pequeno">
                    <div class="rotulo">Valor do documento</div>
                    <div>R$ {{ dados.valor }}</div>
                  </div>
                </div>

                <div class="linha">
                  <div class="col grande">
                    <div class="rotulo">Instruções (Texto de responsabilidade do beneficiário)</div>
                    <div>{{ dados.descricao }}</div>
                    <div>Fatura disponível em: <a :href="dados.linkFatura">{{ dados.linkFatura }}</a></div>
                  </div>
                  <div class="col qrcode">
                    <img
                      :src="qrcodeBase64"
                      alt="QR Code"
                      style="width: 120px; height: 120px"
                    />
                  </div>
                </div>

                <div class="linha">        
                    <div class="col codigo-barras">
                      <vue-barcode 
                        v-if="codigoBarras"
                        :value="codigoBarras" 
                        format="ITF"
                        :width="2"
                        :height="50"
                        :display-value="false">
                      </vue-barcode>
                    </div>
                </div>

                <div class="linha">
                  <div class="col grande">
                    <div class="rotulo">Pagador</div>
                    <div>{{ dados.pagador }} - {{ dados.enderecoPagador }}</div>
                  </div>
                </div>
              </div>


          </div>
        </div>
        
        <!-- Formulário PIX -->
        <div v-if="paymentMethod === 'pix'" class="pix-display">
          <div class="info-alert" style="background: #e0e0e0; padding: 10px; border-radius: 6px; margin-bottom: 20px; text-align: left;">
            <span style="color: #333;">
              <IconInfoCircleFilled stroke={2} style="display: inline-block; vertical-align: middle; color: #3E8DDD;" /> 
              <strong style="display: inline-block;"> O QR Code será gerado após a confirmação dos dados.</strong>
            </span>
          </div>
          <div class="valor-cobranca" style="margin-bottom: 20px; text-align: left;">
            <label style="font-weight: bold; margin-bottom: 8px; display: block;">Valor <span style="color: red;">*</span></label>
            
            <!-- Select para Plano Plus -->
            
            <select
                v-if="selectedPlan === 'plus'"
                v-model="valorSelecionado"
                id="valorPixPlus"
                class="form-control"
                style="width: 100%; padding: 10px; border-radius: 25px; border: 1px solid #ccc;"
                @change="handlePaymentOptionChange"
            >
              <option value="">Selecione um plano</option>
              <option value="179.90">R$ 179,90 mensal</option>
              <option value="1558.80">R$ 1.558,80 anual (com desconto)</option>
            </select>

            <!-- Select para Plano Basic -->
            
            <select
                v-if="selectedPlan === 'basic'"
                v-model="valorSelecionado"
                id="valorPixBasic"
                class="form-control"
                style="width: 100%; padding: 10px; border-radius: 25px; border: 1px solid #ccc;"
                @change="handlePaymentOptionChange" 
            >
              <option value="">Selecione um plano</option>
              <option value="89.90">R$ 89,90 mensal</option>
              <option value="838.80">R$ 838,80 anual (com desconto)</option>
            </select>

          </div>
          <div v-if="valorSelecionado && paymentMethod === 'pix'">
            <h3>Pagamento via Pix</h3>
            <p>Escaneie o QR Code ou copie o código para realizar o pagamento</p>
            <div class="qr-code">
              <canvas id="pix-qr" width="200" height="200"></canvas>
            </div>
            <div class="pix-code">
              <p><strong>Código Pix (Copia e Cola):</strong></p>
              <p id="pix-code-text">{{ dados.pixCode }}</p>
            </div>
            <button class="btn btn-secondary copy-btn" @click="copyPixCode">Copiar código Pix</button>
            <p style="margin-top: 15px; color: #666; font-size: 14px;">
              <strong>Valor:</strong> R$ {{ valorFinalFormatado }}
            </p>
          </div>
        </div>

        <div class="navigation-buttons">
          <button class="nav-button btn" @click="prevStep">
            Voltar
          </button>

          <!-- O botão só aparece se NÃO estiver processando -->
          <button v-if="paymentMethod === 'creditCard' && !isProcessing" class="nav-button btn btn-primary" @click="showConfirmationModal">
            Finalizar Pagamento
          </button>

          <!-- A mensagem de "Processando..." só aparece DURANTE o processamento -->
          <div v-if="isProcessing" class="nav-button btn btn-primary disabled" style="cursor: not-allowed;">
            Processando...
          </div>
        </div>

      </div>

      <div v-if="currentStep === 3" class="step-3">
        <h2>Confirmação de Plano</h2>
        <p>Seu Plano foi criado com sucesso!</p>
        <div class="navigation-buttons">
          <a href="https://app.lubconsulta.com.br" class="nav-button btn btn-primary">Acessar plataforma</a>
        </div>
      </div>
    </div>

    <footer class="site-footer">
      @ lubconsuta.com.br
    </footer>

    <div class="whatsapp-button" @click="toggleWhatsAppChat">
      <div class="pulse">
        <i class="ti ti-brand-whatsapp"></i>
      </div>
    </div>

    <div v-if="showWhatsAppChat" class="whatsapp-chat">
      <div class="chat-header">
        <h3>Envie sua mensagem</h3>
        <button @click="toggleWhatsAppChat" class="close-chat">
          <i class="ti ti-x"></i>
        </button>
      </div>
      <div class="chat-body">
        <textarea v-model="whatsappMessage" placeholder="Digite sua mensagem..."></textarea>
      </div>
      <div class="chat-footer">
        <button @click="sendWhatsAppMessage" class="send-button">
          Enviar <i class="ti ti-send"></i>
        </button>
      </div>
    </div>
  </div>

<transition name="fade">
  <div v-if="showToast" class="coupon-toast" :class="{ show: showToast, hide: !showToast }">
    {{ toastMessage }}
  </div>
</transition>
<div v-if="showToast" class="coupon-toast" 
     :class="{ show: showToast, hide: !showToast }"
     @click="showToast = false">
  {{ toastMessage }}
</div>

    <div v-if="showModal" class="modal-overlay">
        <div class="modal-content">
            <h3 class="modal-title">{{ modalTitle }}</h3>
            <p class="modal-message">{{ modalMessage }}</p>
            <button class="modal-close-btn" @click="closeModal">Fechar</button>
        </div>
    </div>

    <!-- Modal de Alerta de Validação de Contato -->
<div v-if="showContactAlertModal" class="modal-overlay">
    <div class="modal-content">
        <h3 class="modal-title">Validação de Dados</h3>
        <p class="modal-message" style="font-size: 16px;">
            Por favor, confirme se seu Telefone: <strong>{{ personalInfo.phone }}</strong> 
            e E-Mail: <strong>{{ personalInfo.email }}</strong> estão corretos antes de prosseguir.
        </p>
        <button class="modal-close-btn" @click="showContactAlertModal = false">Fechar</button>
    </div>
</div>

<!-- Modal de Confirmação de Pagamento (Cartão) -->
<div v-if="showPaymentConfirmationModal" class="modal-overlay">
    <div class="modal-content payment-confirmation-modal">
        <h3 class="modal-title">Confirmação de Pagamento</h3>
        <div class="payment-details">
            <div class="detail-item"><strong>Valor:</strong> {{ selectedOptionDescription }}</div>
            <div class="detail-item" v-if="valorFinalCalculado > 0"><strong>Valor Final:</strong> R$ {{ valorFinalFormatado }}</div>
            <div class="detail-item"><strong>Últimos 4 dígitos:</strong> {{ lastFourDigits }}</div>
        </div>
        <div class="modal-actions">
            <button class="btn btn-secondary" @click="cancelPayment">Cancelar</button>
            <button class="btn btn-primary" @click="confirmPayment">Confirmar Pagamento</button>
        </div>
    </div>
</div>
    
    <LoadingSpinner :show="showLoadingSpinner" message="Checando - Aguarde ..." />
  
</template>

<script>
import QRCode from 'qrcode'
import VueBarcode from '@chenfengyuan/vue-barcode'; 
import apiClient from '@/services/api.js'; 
import LoadingSpinner from '@/modules/planos/LoadingSpinner.vue';

export default {
  name: 'PlanosViewThyago',
  components: { 
    VueBarcode,
    LoadingSpinner 
  },
  data() {
    return {      
      isSubmittingData: false, 
      paymentMonitorInterval: null, 
      monitorAttempts: 0,           
      maxMonitorAttempts: 100,      // 5 minutos / 3 segundos por tentativa = 100 tentativas
      isProcessing: false,
      showModal: false,
      modalTitle: '',
      modalMessage: '',
      paymentSuccessful: false,
      tipoCobranca: '',
      valorSelecionado: '',
      pixCode: '',
      showPixDetails: false,
      fieldsLocked: false,
      currentStep: 1,
      selectedPlan: null,
      showWhatsAppChat: false,
      whatsappMessage: '',
      showBoleto: false,
      showLoadingSpinner: false, 
      showContactConfirmationModal: false,
      showContactAlertModal: false,
      hasShownContactModal: false,
      lastValidatedCnpj: '', 
      loadingMessage: 'Gerando pagamento...',
      phonePlaceholder: '(85) 9 9999-9999', 
      emailPlaceholder: 'seu@email.com',
      coupon: {
        code: '',
        applied: false,
        discount: 0 
      },
      couponsList: [
        { "id": "1", "plano": "Basic", "cupon": "BSCPROMO10", "percentual": "10" },
        { "id": "2", "plano": "Basic", "cupon": "BSSAVE10", "percentual": "10" },
        { "id": "3", "plano": "Basic", "cupon": "BSDISCOUNT10", "percentual": "10" },
        { "id": "4", "plano": "Basic", "cupon": "BSCUPOM10", "percentual": "10" },
        { "id": "5", "plano": "Basic", "cupon": "BSOFFER10", "percentual": "10" },
        { "id": "11", "plano": "Plus", "cupon": "PLPROMO10", "percentual": "10" },
        { "id": "12", "plano": "Plus", "cupon": "PLSAVE10", "percentual": "10" },
        { "id": "13", "plano": "Plus", "cupon": "PLDISCOUNT10", "percentual": "10" },
        { "id": "21", "plano": "Basic", "cupon": "BSCPROMO20", "percentual": "20" },
        { "id": "26", "plano": "Plus", "cupon": "PLPROMO20", "percentual": "20" }
      ],
      billingAddress: {
        street: '',
        number: '',
        bairro: '',
        complement: '',
        zipCode: '',
        country: 'Brasil',
        state: '',
        city: ''
      },
      fieldStates: {
        document: false,
        fullName: true,
        street: true,
        zipCode: true,
        number: true,
        bairro: true,
        complement: true,
        country: true,
        state: true,
        city: true,
      },
      personalInfo: {
        fullName: '',
        document: '',
        phone: '',
        email: ''
      },
      validation: {
        phoneTouched: false,
        emailTouched: false,
        phoneValid: true,
        emailValid: true
      },
      paymentMethod: 'creditCard',
      creditCard: {
        number: '',
        holderName: '',
        expiryDate: '',
        cvv: ''
      },
      dados: {
        beneficiario: 'INOVAUTO INFO STARTUP LTDA',
        cnpjBeneficiario: '54.126.790/0001-85',
        vencimento: '',
        nossoNumero: '',
        valor: '',
        netValue: '',
        descricao: '',
        linkFatura: '',
        pagador: '',
        enderecoPagador: '',
        invoiceNumber: '',
        status: ''
      },                  
      linhaDigitavel: '',
      codigoBarras: '',
      qrcodeBase64: '',
      showCoupon: false,
      showPlanDetails: false,
      requiredFields: [
        'billingAddress.street',
        'billingAddress.zipCode',
        'billingAddress.number',
        'billingAddress.state',
        'billingAddress.city',
        'personalInfo.fullName',
        'personalInfo.document',
        'personalInfo.phone',
        'personalInfo.email'
      ],
      lastSubmittedData: null,
      isLoading: false,
      showToast: false,
      toastMessage: '',
      toastTimeout: null,
      clienteId: null,
      assinaturaId: null,
      qrCodeData: null,
      showPaymentConfirmationModal: false
    }
  },

  computed: {
    valorFinalCalculado() {
      if (!this.valorSelecionado) return 0;
      const valorNumerico = parseFloat(this.valorSelecionado);
      let valorComLimites = valorNumerico;
      if (valorNumerico >= 838.80 && valorNumerico <= 838.86) {
        valorComLimites = 838.80;
      } else if (valorNumerico >= 1558.80 && valorNumerico <= 1558.86) {
        valorComLimites = 1558.80;
      }
      if (this.coupon.applied && this.coupon.discount > 0) {
        const desconto = valorComLimites * (this.coupon.discount / 100);
        return valorComLimites - desconto;
      }
      return valorComLimites;
    },
    valorFinalFormatado() {
      if (!this.valorSelecionado) return '';
      return `${this.valorFinalCalculado.toFixed(2).replace('.', ',')}`;
    },
    lastFourDigits() {
      if (!this.creditCard.number) return '';
      const cleaned = this.creditCard.number.replace(/\s/g, '');
      return cleaned.slice(-4);
    },
    selectedOptionDescription() {
      if (!this.valorSelecionado) return '';
      const options = {
        '179.90': 'R$ 179,90 mensal',
        '1558.80': 'R$ 1.558,80 anual (com desconto)',
        '1558.82': 'Em 2x de R$ 779,40 sem juros',
        '1558.83': 'Em 3x de R$ 519,60 sem juros',
        '1558.84': 'Em 4x de R$ 389,70 sem juros',
        '1558.85': 'Em 5x de R$ 311,76 sem juros',
        '1558.86': 'Em 6x de R$ 259,80 sem juros',
        '89.90': 'R$ 89,90 mensal',
        '838.80': 'R$ 838,80 anual (com desconto)',
        '838.82': 'Em 2x de R$ 419,40 sem juros',
        '838.83': 'Em 3x de R$ 279,60 sem juros',
        '838.84': 'Em 4x de R$ 209,70 sem juros',
        '838.85': 'Em 5x de R$ 167,76 sem juros',
        '838.86': 'Em 6x de R$ 139,80 sem juros'
      };
      return options[this.valorSelecionado] || '';
    }
  },

  methods: {
    onCnpjInput(e) {
      let val = e.target.value.replace(/\D/g, "").slice(0, 14);
      val = val.replace(/^(\d{2})(\d)/, "$1.$2");
      val = val.replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3");
      val = val.replace(/\.(\d{3})(\d)/, ".$1/$2");
      val = val.replace(/(\d{4})(\d)/, "$1-$2");
      this.personalInfo.document = val;
    },

    onPhoneInput(e) {
      let val = e.target.value.replace(/\D/g, "").slice(0, 11);
      if (val.length > 2 && val.length <= 6) {
        val = `(${val.slice(0, 2)}) ${val.slice(2)}`;
      } else if (val.length > 6) {
        val = `(${val.slice(0, 2)}) ${val.slice(2, 3)} ${val.slice(3, 7)}-${val.slice(7)}`;
      } else if (val.length > 0) {
        val = `(${val}`;
      }
      this.personalInfo.phone = val;
    },

    checkEmailPattern() {
      const email = this.personalInfo.email.toLowerCase();
      if ((email.endsWith("@gmail.com") || email.endsWith(".br")) && !this.hasShownContactModal) {
        this.triggerContactModal();
      }
    },

    triggerContactModal() {
      if (this.personalInfo.email && this.personalInfo.phone && !this.hasShownContactModal) {
        this.showContactAlertModal = true;
        this.hasShownContactModal = true;
      }
    },

    validatePhoneField() {
      this.validation.phoneTouched = true;
      this.validation.phoneValid = !!this.personalInfo.phone;
    },

    validateEmailField() {
      this.validation.emailTouched = true;
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      this.validation.emailValid = emailRegex.test(this.personalInfo.email) && !!this.personalInfo.email;
    },

    validateContactInfoBeforePayment() {
      this.validatePhoneField();
      this.validateEmailField();
      if (!this.validation.phoneValid || !this.validation.emailValid) {
        this.modalTitle = 'Preenchimento Necessário';
        this.modalMessage = 'Por favor, preencha corretamente os campos de Telefone e E-mail antes de selecionar o pagamento.';
        this.showModal = true;
        return false;
      }
      return true;
    },

    handlePaymentOptionChange(event) {
      const oldValue = this.valorSelecionado;
      if (event.target.value !== '' && !this.validateContactInfoBeforePayment()) {
        this.valorSelecionado = oldValue;
        return;
      }
      if (this.paymentMethod === 'pix') this.handleValorPixChange();
      else if (this.paymentMethod === 'boleto') this.handleValorBoletoChange();
    },

    async handleCnpjNavigation() {
      await this.fetchAndPopulateCustomerData();
      this.$nextTick(() => {
        if (this.$refs.phoneInput) this.$refs.phoneInput.focus();
      });
    },

    async fetchAndPopulateCustomerData() {
      const doc = this.personalInfo.document.replace(/\D/g, '');
      if (this.isSubmittingData || (doc === this.lastValidatedCnpj && doc !== '')) return;
      if (doc.length > 0 && doc.length !== 14) {
        this.modalTitle = "Erro";
        this.modalMessage = "CNPJ inválido.";
        this.showModal = true;
        return;
      }
      this.isSubmittingData = true;
      this.showLoadingSpinner = true;
      this.loadingMessage = "Validando CNPJ na SEFAZ";
      try {
        await this.consultarCNPJ();
        this.lastValidatedCnpj = doc; 
      } catch (error) {
        this.lastValidatedCnpj = '';
        this.modalTitle = "CNPJ Inválido";
        this.showModal = true;
      } finally {
        this.showLoadingSpinner = false;
        this.isSubmittingData = false;
      }
    },

    async consultarCNPJ() {
      const cnpj = this.personalInfo.document.replace(/\D/g, '');
      const response = await fetch(`https://publica.cnpj.ws/cnpj/${cnpj}`);
      if (!response.ok) throw new Error('Invalido');
      const data = await response.json();
      this.personalInfo.fullName = data.razao_social;
      this.billingAddress.street = `${data.estabelecimento.tipo_logradouro || ''} ${data.estabelecimento.logradouro || ''}`.trim();
      this.billingAddress.number = data.estabelecimento.numero || '';
      this.billingAddress.bairro = data.estabelecimento.bairro || '';
      this.billingAddress.complement = data.estabelecimento.complemento || '';
      this.billingAddress.zipCode = data.estabelecimento.cep || '';
      this.billingAddress.city = data.estabelecimento.cidade?.nome || '';
      this.billingAddress.state = data.estabelecimento.estado?.sigla || '';
      const ddd = data.estabelecimento.ddd1 || '';
      const tel = data.estabelecimento.telefone1 || '';
      this.phonePlaceholder = ddd && tel ? this.cleanAndFormatPhone(`${ddd}${tel}`) : '(85) 9 9999-9999';
      this.emailPlaceholder = data.estabelecimento.email || 'seu@email.com';
    },

    showConfirmationModal() {
      if (!this.valorSelecionado || !this.creditCard.number || !this.creditCard.holderName || 
          !this.creditCard.expiryDate || !this.creditCard.cvv) {
        this.modalTitle = 'Campos incompletos';
        this.modalMessage = 'Por favor, preencha todos os dados do cartão de crédito.';
        this.showModal = true;
        return;
      }
      if (!this.validateContactInfoBeforePayment()) return;
      this.showPaymentConfirmationModal = true;
    },

    cancelPayment() {
      this.showPaymentConfirmationModal = false;
      this.creditCard = { number: '', holderName: '', expiryDate: '', cvv: '' };
    },

    confirmPayment() {
      this.showPaymentConfirmationModal = false;
      this.finalizeCreditCardPayment();
    },

    async finalizeCreditCardPayment() {
      this.isProcessing = true;
      try {
        await this.createCustomerIfNeeded();
        const [expiryMonth, expiryYear] = this.creditCard.expiryDate.split('/');
        let cycle = (this.valorSelecionado.startsWith('1558') || this.valorSelecionado.startsWith('838')) ? 'YEARLY' : 'MONTHLY';
        
        const assinaturaData = {
          customer: this.clienteId,
          billingType: "CREDIT_CARD",
          nextDueDate: new Date().toISOString().split('T')[0],
          value: this.valorFinalCalculado, 
          cycle: cycle,
          description: `Assinatura LubConsulta ${this.selectedPlan === 'basic' ? 'Basic' : 'Plus'}`,
          creditCard: {
            holderName: this.creditCard.holderName,
            number: this.creditCard.number.replace(/\s/g, ''),
            expiryMonth, expiryYear: "20" + expiryYear, ccv: this.creditCard.cvv
          },
          creditCardHolderInfo: {
            name: this.personalInfo.fullName,
            email: this.personalInfo.email,
            representante: 'thyago',
            cpfCnpj: this.personalInfo.document.replace(/\D/g, ''),
            postalCode: this.billingAddress.zipCode.replace(/\D/g, ''),
            addressNumber: this.billingAddress.number,
            phone: this.personalInfo.phone.replace(/\D/g, ''),
            mobilePhone: this.personalInfo.phone.replace(/\D/g, '')
          }
        };
        const response = await apiClient.post('/criar-assinatura-credcard', assinaturaData);
        if (response.status < 300) {
          this.paymentSuccessful = true;
          await this.sendToZarpon();
          this.currentStep = 3;
        }
      } catch (error) {
        this.modalTitle = "Erro na Operação";
        this.modalMessage = error.message;
      } finally { this.isProcessing = false; this.showModal = true; }
    },

    async handleValorPixChange() {
      if (this.isProcessing) return;
      this.isProcessing = true; this.showLoadingSpinner = true;
      try {
        await this.createCustomerIfNeeded();
        const ciclo = this.valorFinalCalculado > 200 ? "YEARLY" : "MONTHLY";
        const payload = {
          customer: this.clienteId,
          billingType: "PIX",
          nextDueDate: new Date().toISOString().split('T')[0],
          value: this.valorFinalCalculado, 
          cycle: ciclo,
          description: this.selectedPlan === 'basic' ? "PLANO BASIC" : "PLANO PLUS",
          personalInfo: { ...this.personalInfo, representante: 'thyago' },
          selectedPlanName: this.selectedPlan
        };
        const res = await apiClient.post('/criar-assinatura', payload);
        this.assinaturaId = res.data.id;
        const cobrancaId = await this.aguardarCobrancaDisponivel();
        const qrRes = await apiClient.get(`/qrCode?cobranca=${cobrancaId}`);
        this.qrCodeData = qrRes.data;
        this.atualizarInterfacePix();
        await this.sendToZarpon();
        this.monitorPaymentStatus();
      } catch (error) {
        this.modalTitle = "Erro no PIX"; this.modalMessage = error.message; this.showModal = true;
      } finally { this.isProcessing = false; this.showLoadingSpinner = false; }
    },

    async handleValorBoletoChange() {
      if (this.isProcessing) return;
      this.isProcessing = true; this.showLoadingSpinner = true;
      try {
        await this.createCustomerIfNeeded();
        const ciclo = (this.valorSelecionado === '89.90' || this.valorSelecionado === '179.90') ? "MONTHLY" : "YEARLY";
        const payload = {
          customer: this.clienteId,
          billingType: "BOLETO", 
          nextDueDate: new Date().toISOString().split('T')[0],
          value: this.valorFinalCalculado, 
          cycle: ciclo,
          description: this.selectedPlan === 'basic' ? "PLANO BASIC" : "PLANO PLUS",
          personalInfo: { ...this.personalInfo, representante: 'thyago' },
          selectedPlanName: this.selectedPlan
        };
        const res = await apiClient.post('/criar-assinatura', payload);
        this.assinaturaId = res.data.id;
        const cobrancaId = await this.aguardarCobrancaDisponivel();
        await this.obterDadosBoleto(cobrancaId);
        this.showBoleto = true;
        await this.sendToZarpon();
        this.monitorPaymentStatus();
      } catch (error) {
        console.error('Erro no Boleto:', error);
      } finally { this.isProcessing = false; this.showLoadingSpinner = false; }
    },

    async createCustomerIfNeeded() {
      const cleanDoc = this.personalInfo.document.replace(/\D/g, '');
      try {
        const consulta = await apiClient.get(`/consultar-cliente/${cleanDoc}`);
        if (consulta.data?.totalCount > 0) {
          this.clienteId = consulta.data.data[0].id; return;
        }
      } catch (e) { 
        console.log('Cliente não existe, criando...');
      }
      const newCustomer = {
        name: this.personalInfo.fullName,
        cpfCnpj: cleanDoc,
        email: this.personalInfo.email.trim(),
        mobilePhone: this.personalInfo.phone.replace(/\D/g, ''),
        postalCode: this.billingAddress.zipCode.replace(/\D/g, ''),
        address: this.billingAddress.street,
        groupName: this.selectedPlan === 'basic' ? "PLANO BASIC" : "PLANO PLUS"
      };
      const res = await apiClient.post('/cadastrar-cliente', newCustomer);
      this.clienteId = res.data.id;
    },

    async aguardarCobrancaDisponivel() {
      for (let i = 0; i < 5; i++) {
        const res = await apiClient.get(`/listarCobranca?customer=${this.clienteId}`);
        if (res.data.id) return res.data.id;
        if (res.data.data?.[0]?.id) return res.data.data[0].id;
        await new Promise(r => setTimeout(r, 1000));
      }
      throw new Error('Cobrança não encontrada.');
    },

    atualizarInterfacePix() {
      const canvas = document.getElementById('pix-qr');
      if (canvas) QRCode.toCanvas(canvas, this.qrCodeData.payload, { width: 200 });
      this.pixCode = this.qrCodeData.payload;
      this.showPixDetails = true;
    },

    async obterDadosBoleto(cobrancaId) {
      const cobRes = await apiClient.get(`/listarCobranca?customer=${this.clienteId}`);
      const barRes = await apiClient.get(`/barCode?cobranca=${cobrancaId}`);
      const qrRes = await apiClient.get(`/qrCode?cobranca=${cobrancaId}`);
      this.dados.dtcria = this.formatarData(cobRes.data.dateCreated);
      this.dados.vencimento = this.formatarData(cobRes.data.dueDate);
      this.dados.valor = this.formatarValor(cobRes.data.value);
      this.dados.linkFatura = cobRes.data.invoiceUrl;
      this.dados.pagador = this.personalInfo.fullName;
      this.linhaDigitavel = barRes.data.identificationField;
      this.codigoBarras = barRes.data.identificationField;
      this.qrcodeBase64 = `data:image/png;base64,${qrRes.data.encodedImage}`;
    },

    async monitorPaymentStatus() {
      if (this.paymentMonitorInterval) clearInterval(this.paymentMonitorInterval);
      this.monitorAttempts = 0;
      this.paymentMonitorInterval = setInterval(async () => {
        if (this.monitorAttempts >= this.maxMonitorAttempts) return clearInterval(this.paymentMonitorInterval);
        try {
          const response = await apiClient.get(`/listarCobranca?customer=${this.clienteId}`);
          if (response.data.status === 'RECEIVED' || response.data.status === 'CONFIRMED') {
            clearInterval(this.paymentMonitorInterval);
            this.modalTitle = "Pagamento Confirmado!";
            this.currentStep = 3; this.showModal = true; this.paymentSuccessful = true;
          }
        } catch (e) {
          console.warn('Monitorando...');
        }
        this.monitorAttempts++;
      }, 3000);
    },

    async sendToZarpon() {
      const isAnual = this.valorFinalCalculado > 200;
      let webhook = '';
      if (this.selectedPlan === 'basic') {
        webhook = isAnual ? 'https://beta.zarpon.com.br/webhooks/start/mOtY_J5Vn2nlLMexC-VV6Q.UDJ0ck1QWHhSeWk5b0FlcQ.NNGMEZDDfUOOteUEOL1hB5PshLUTcO8aCpTUP5yFIDY' : 'https://beta.zarpon.com.br/webhooks/start/OHInukjw0vRUxB1zKbNV9g.a3ZRWllyVVM0eXVDRU9TRQ.QinTtXW5t9TMru6UKpz4oIYSTvbrgyEDMDRphuY6NgQ';
      } else {
        webhook = isAnual ? 'https://beta.zarpon.com.br/webhooks/start/oNz0T1uGgGwbKR-F0A7JBw.WGVqLXkxam03ZEl3OEdJdw.U3P9sBRMOn2SRJvQdLw-2DfJe9ynYbtuU164Tn_3QS8' : 'https://beta.zarpon.com.br/webhooks/start/sbqubc4T-InHGxHHOSup8g.amRsUTlMbkI3TTdYaG9vNA.bMfn2ToOyqzLzGXgY1kl9uQvgstDRD0W2SMmrvuoDLQ';
      }
      const phone = '55' + this.personalInfo.phone.replace(/\D/g, '');
      const data = {
        lead: {
          name: this.personalInfo.fullName, phone, email: this.personalInfo.email.trim(),
          variables: [{ name: "cidade", content: this.billingAddress.city }, { name: "plano", content: this.selectedPlan }]
        }
      };
      await fetch(webhook, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(data) });
    },

    stopPaymentMonitor() { if (this.paymentMonitorInterval) clearInterval(this.paymentMonitorInterval); },
    validateCoupon() {
      const found = this.couponsList.find(c => c.cupon === this.coupon.code.trim().toUpperCase());
      if (found && found.plano.toLowerCase() === this.selectedPlan.toLowerCase()) {
        this.coupon.applied = true; this.coupon.discount = parseInt(found.percentual);
        this.showToastMessage("Cupom aplicado!");
      } else { this.showToastMessage("Cupom inválido."); }
    },
    showToastMessage(m) { this.toastMessage = m; this.showToast = true; setTimeout(() => { this.showToast = false; }, 3000); },
    formatarData(d) { if (!d) return ''; const [a, m, dia] = d.split('-'); return `${dia}/${m}/${a}`; },
    formatarValor(v) { return parseFloat(v).toFixed(2).replace('.', ','); },
    cleanAndFormatPhone(v) { return v.replace(/\D/g, ''); },
    nextStep() { if (this.currentStep < 3) this.currentStep++; },
    prevStep() { this.stopPaymentMonitor(); if (this.currentStep > 1) this.currentStep--; },
    selectPlan(p) { this.selectedPlan = p; this.nextStep(); },
    toggleWhatsAppChat() { this.showWhatsAppChat = !this.showWhatsAppChat; },
    sendWhatsAppMessage() {
      if (this.whatsappMessage.trim()) {
        window.open(`https://wa.me/5585992282002?text=${encodeURIComponent(this.whatsappMessage)}`, '_blank');
        this.whatsappMessage = ''; this.showWhatsAppChat = false;
      }
    },
    toggleCoupon() { this.showCoupon = !this.showCoupon; },
    togglePlanDetails() { this.showPlanDetails = !this.showPlanDetails; },
    copyPixCode() { navigator.clipboard.writeText(this.pixCode).then(() => alert('Pix copiado!')); },
    closeModal() { if (this.paymentSuccessful) this.nextStep(); this.showModal = false; }
  },

  watch: {
    valorFinalCalculado(n, o) {
      if (n !== 0 && n !== o) {
        if (this.paymentMethod === 'pix') this.handleValorPixChange();
        else if (this.paymentMethod === 'boleto') this.handleValorBoletoChange();
      }
    },
    paymentMethod() {
      this.stopPaymentMonitor(); this.valorSelecionado = ''; this.showPixDetails = false; this.showBoleto = false;
      this.coupon.applied = false; this.coupon.code = '';
    },
    'creditCard.expiryDate'(v) {
      let c = v.replace(/\D/g, '').substring(0, 4);
      if (c.length > 2) c = c.substring(0, 2) + '/' + c.substring(2);
      this.creditCard.expiryDate = c;
    }
  }
}
</script>

<style scoped>
/* Estilos para o modal de confirmação de pagamento */
.payment-confirmation-modal {
  max-width: 500px;
  text-align: left;
}

.payment-details {
  margin: 20px 0;
  padding: 15px;
  background-color: #f9f9f9;
  border-radius: 8px;
  border-left: 4px solid #3E8DDD;
}

.detail-item {
  margin-bottom: 10px;
  padding: 8px 0;
  border-bottom: 1px solid #eee;
}

.detail-item:last-child {
  border-bottom: none;
  margin-bottom: 0;
}

.detail-item strong {
  color: #333;
  min-width: 150px;
  display: inline-block;
}

.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 20px;
}

.btn-secondary {
  background-color: #6c757d;
  border-color: #6c757d;
}

.btn-secondary:hover {
  background-color: #5a6268;
  border-color: #545b62;
}
</style>



<style scoped>

.input-invalid {
  border-color: #e74c3c !important; /* Borda vermelha */
  background-color: rgba(231, 76, 60, 0.08) !important; /* Fundo vermelho bem fraquinho */
}

/* Opcional: para o foco, manter o vermelho */
.input-invalid:focus {
  border-color: #c0392b !important;
  box-shadow: 0 0 0 0.2rem rgba(231, 76, 60, 0.25) !important;
}

/* Garanta que o estilo padrão do input ainda seja aplicado quando válido */
.form-input {
  /* Seus estilos padrão aqui */
  border: 1px solid #ccc; /* Exemplo de borda padrão */
  background-color: #fff; /* Exemplo de fundo padrão */
  padding: 10px;
  border-radius: 4px;
  width: 100%;
}

.boleto-container {
  max-width: 900px;
  margin: 0 auto;
  font-family: Arial, sans-serif;
  background-color: white;
  color: black;
}

.linha-digitavel {
  border: 2px solid black;
  padding: 8px;
  font-size: 18px;
  font-weight: bold;
  text-align: center;
  margin-bottom: 8px;
}

.boleto-box {
  border: 2px solid black;
}

.linha {
  display: flex;
  border-bottom: 1px solid black;
}

.linha:last-child {
  border-bottom: none;
}

.col {
  border-right: 1px solid black;
  padding: 6px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.col:last-child {
  border-right: none;
}

.col.grande {
  flex: 3;
}

.col.pequeno {
  flex: 1.2;
}

.col.logo {
  flex: 1;
  justify-content: center;
  align-items: center;
}

.col.numero {
  flex: 0.5;
  font-weight: bold;
  font-size: 18px;
  align-items: center;
}

.col.linha-digitavel-right {
  flex: 2;
  font-weight: bold;
  font-size: 14px;
  align-items: center;
}

.col.qrcode {
  flex: 1;
  justify-content: center;
  align-items: center;
}

.col.codigo-barras {
  flex: 3;
  justify-content: center;
  align-items: center;
}

.codigo-barras-texto {
  font-family: 'Libre Barcode 128', monospace;
  font-size: 40px;
}

.rotulo {
  font-size: 10px;
  color: gray;
}

a {
  color: blue;
  text-decoration: underline;
  font-size: 10px;
}


.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background: white;
  padding: 25px 30px;
  border-radius: 8px;
  box-shadow: 0 4px 15px rgba(0,0,0,0.2);
  width: 90%;
  max-width: 450px;
  text-align: center;
}

.modal-title {
  margin-top: 0;
  margin-bottom: 15px;
  font-size: 1.5rem;
  color: #333;
}

.modal-message {
  margin-bottom: 25px;
  font-size: 1rem;
  color: #555;
  white-space: pre-wrap; /* Para quebras de linha em mensagens de erro */
}

.modal-close-btn {
  background-color: #3E8DDD;
  color: white;
  border: none;
  padding: 10px 25px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 1rem;
  font-weight: bold;
  transition: background-color 0.2s;
}

.modal-close-btn:hover {
  background-color: #3477bb;
}

/* NOVO: Estilo para botão desabilitado */
button:disabled {
  background-color: #cccccc;
  cursor: not-allowed;
}



@media print {
  body {
    visibility: hidden;
  }

  .boleto-container {
    visibility: visible;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
  }
}

@keyframes toast-fadein {
  from { opacity: 0; transform: translate(-50%, -100%); }
  to { opacity: 1; transform: translate(-50%, -50%); }
}

@keyframes toast-fadeout {
  from { opacity: 1; transform: translate(-50%, -50%); }
  to { opacity: 0; transform: translate(-50%, -100%); }
}

/* Adicione ao seu arquivo CSS */
.form-input-size-4 {
  flex: 0 0 calc(33.333% - 10px) !important;
  max-width: calc(33.333% - 10px) !important;
}

.form-input-size-8 {
  flex: 0 0 calc(66.666% - 10px) !important;
  max-width: calc(66.666% - 10px) !important;
}

.disabled-field {
  background-color: #f5f5f5;
  color: #666;
  cursor: not-allowed;
}

.unlock-btn {
  margin-top: 15px;
  padding: 8px 15px;
  background-color: #f8f9fa;
  border: 1px solid #ddd;
  border-radius: 4px;
  cursor: pointer;
}

.unlock-btn:hover {
  background-color: #e9ecef;
}

.icone-svg {
 flex-shrink: 0; /* evita encolher */
  width: 24px;
  height: 24px;
  margin-right: 8px;
}

.icone {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.narrow-wizard {
  max-width: 800px;
  margin: 0 auto;
  padding: 0px;
}

.narrow-content {
  max-width: 800px;
  margin: 0 auto;
  padding: 0 15px;
}

.narrow-title {
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
  padding: 0 15px;
  text-align: center;
}

.wizard {
  display: flex;
  justify-content: space-between;
}

.step {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.step-info {
  max-width: 200px;
}

.planos-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
  font-family: Arial, sans-serif;
  position: relative;
  min-height: 100vh;
  padding-bottom: 60px;
  background-color: #fff; 
}

.logo-container {
  text-align: center;
  margin-bottom: 30px;
}

.logo {
  max-width: 350px;
  height: auto;
}

.wizard {
  display: flex;
  justify-content: space-between;
  margin-bottom: 40px;
  position: relative;
}

.wizard::before {
  content: '';
  position: absolute;
  top: 20px;
  left: 0;
  right: 0;
  height: 2px;
  background-color: #e0e0e0;
  z-index: 1;
}

.step {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  z-index: 2;
  flex: 1;
}

.step-number {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: #e0e0e0;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;
  font-weight: bold;
}

.step.active .step-number {
  background-color: #E4A64E;
}

.step-info {
  text-align: center;
  padding: 0 10px;
}

.step-title {
  font-weight: bold;
  margin-bottom: 5px;
}

.step-description {
  font-size: 0.9em;
  color: #666;
}

.step-content {
  background-color: #fff;
  padding: 30px;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.step-content h2 {
  color: #333;
  margin-bottom: 10px;
}

.subtitle {
  color: #666;
  margin-bottom: 30px;
  text-align: center;
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
  padding: 0 15px;
}

.plans-container {
  display: flex;
  gap: 2rem;
  flex-wrap: wrap;
  justify-content: center;
}

.plan-card {
  flex: 1;
  min-width: 300px;
  max-width: 100%;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  border: 1px solid #e0e0e0;
  transition: transform 0.3s ease;
  display: flex;
  flex-direction: column;
  min-height: 600px;
}

.plan-card2 {
  flex: 1;
  min-width: 300px;
  max-width: 100%;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  border: 1px solid #e0e0e0;
  transition: transform 0.3s ease;
  display: flex;
  flex-direction: column;
}

.plan-card:hover {
  transform: translateY(-5px);
}

.plan-card.plus {
  border-top: 4px solid #E4A64E;
}

.plan-header {
  background-color: #E4A64E;
  color: white;
  padding: 20px;
  text-align: center;
}

.plan-sub {
  background-color: #ffffff;
  color: #000000;
  padding: 10px;
}

.plan-header h2 {
  margin: 0;
  color: #ffffff;
}

.plan-pricing {
  padding: 20px;
  text-align: center;
  border-bottom: 1px solid #e0e0e0;
}

.monthly, .yearly {
  margin-bottom: 15px;
}

.price {
  font-size: 1.8em;
  font-weight: bold;
  color: #333;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  line-height: 1;
}

.price::before {
  content: "R$";
  font-size: 0.6em;
  align-self: flex-start;
  margin-right: 4px;
  margin-top: 0.2em;
}

.period {
  color: #666;
  font-size: 0.9em;
}

.savings {
  background-color: #d9d8d6;
  border-radius: 6px;
  padding: 8px 12px;
  display: inline-block;
  margin-top: 10px;
  color: #000000;
  font-size: 0.9em;
}

.savings2 {
  background-color: #53b42f;
  border-radius: 6px;
  padding: 8px 12px;
  display: inline-block;
  margin-top: 10px;
  color: #ffffff;
  font-size: 0.9em;
}

.plan-features {
  padding: 20px;
  flex-grow: 1;
  gap: 12px; 
}

.feature {
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
}

.feature i {
  color: #E4A64E;
  margin-right: 10px;
  font-size: 1.2em;
  vertical-align: middle;
}

.feature .menu-icon {
  color: #E4A64E;
  margin-right: 10px;
  width: 1.2em;
  height: 1.2em;
  stroke-width: 1.5;
}

.feature input[type="checkbox"] {
  margin-right: 10px;
}

.select-button {
  display: block;
  width: 100%;
  padding: 15px;
  background-color: #E4A64E;
  color: white;
  border: none;
  font-weight: bold;
  cursor: pointer;
  transition: background-color 0.3s;
}

.select-button:hover {
  background-color: #E4A64E;
}

.navigation-buttons {
  display: flex;
  width: 100%;
  gap: 10px; 
  justify-content: space-between;
  margin-top: 30px;
}

.back-button, .next-button {
  padding: 10px 20px;
  border: none;
  border-radius: 30px;
  cursor: pointer;
  font-weight: bold;
}

.back-button {
  padding: 15px;
  background-color: #f1f1f1;
  color: #333;
}

.nav-button {
  flex: 1; /* Isso fará com que cada botão ocupe igual espaço */
  min-width: 0; /* Importante para evitar problemas de overflow */
  padding: 2px; /* Ajuste o padding conforme necessário */
  text-align: center;
}

.next-button {
  background-color: #E4A64E;
  color: white;
}

/* Estilos para o botão de voltar no topo */
.back-button-top {
  position: absolute;
  top: 20px;
  right: 20px;
}

.back-link {
  display: flex;
  align-items: center;
  gap: 5px;
  color: #E4A64E;
  text-decoration: none;
  font-weight: bold;
  padding: 8px 12px;
  border: 1px solid #E4A64E;
  border-radius: 4px;
  transition: all 0.3s ease;
}

.back-link:hover {
  background-color: #E4A64E;
  color: white;
}

/* Estilos para o footer */
.site-footer {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 10px;
  text-align: left;
  color: #666;
  font-size: 0.9em;
  border-top: 1px solid #e0e0e0;
}

/* Estilos para o botão do WhatsApp */
.whatsapp-button {
  position: fixed;
  bottom: 30px;
  right: 30px;
  width: 60px;
  height: 60px;
  background-color: #25D366;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  z-index: 1000;
}

.whatsapp-button i {
  color: white;
  font-size: 30px;
}

.pulse {
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
}

/* Estilos para o chat do WhatsApp */
.whatsapp-chat {
  position: fixed;
  bottom: 100px;
  right: 30px;
  width: 300px;
  background-color: white;
  border-radius: 10px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
  z-index: 1001;
  overflow: hidden;
}

.chat-header {
  background-color: #075E54;
  color: white;
  padding: 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.chat-header h3 {
  margin: 0;
  font-size: 16px;
}

.close-chat {
  background: none;
  border: none;
  color: white;
  cursor: pointer;
  font-size: 18px;
}

.chat-body {
  padding: 15px;
}

.chat-body textarea {
  width: 100%;
  height: 100px;
  border: 1px solid #ddd;
  border-radius: 5px;
  padding: 10px;
  resize: none;
}

.chat-footer {
  padding: 10px 15px;
  text-align: right;
  background-color: #f5f5f5;
}

.send-button {
  background-color: #25D366;
  color: white;
  border: none;
  padding: 8px 15px;
  border-radius: 5px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 5px;
} 

.send-button:hover {
  background-color: #128C7E;
}

.plan-name {
  background-color: #E4A64E;
  color: white;
  padding: 6px 12px;
  border-radius: 6px;
  display: inline-block;
  font-size: 14px;
  margin-bottom: 15px;
}

.collapse-item {
  border-bottom: 1px solid #eee;
  padding: 15px 0;
}

.collapse-item:last-child {
  border-bottom: none;
}

.collapse-header {
  display: flex;
  align-items: center;
  cursor: pointer;
  font-weight: 500;
}

.collapse-icon {
  margin-left: 10px;
  transition: transform 0.3s;
}

.collapse-icon.expanded {
  transform: rotate(180deg);
}

.collapse-content {
  margin-top: 15px;
  padding-left: 20px;
}


.form-section {
  background: white;
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 20px;
  width: 100%;
  box-sizing: border-box;
}

.form-title {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 20px;
  text-align: left;
  width: 100%;
}

.form-row {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  margin-bottom: 15px;
  width: 100%;
}

.form-group {
  flex: 1 1 100%;
  min-width: 0;
}

.form-label {
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
  font-size: 14px;
  text-align: left;
}

.required {
  color: #dc3545;
}

.form-input, .form-select {
  width: 100%;
  padding: 12px 15px;
  border: 1px solid #ddd;
  border-radius: 38px;
  font-size: 14px;
  box-sizing: border-box;
}

.form-input:focus, .form-select:focus {
  outline: none;
  border-color: #E4A64E;
  box-shadow: 0 0 0 2px rgba(228, 166, 78, 0.1);
}

/* Estilos para desktop */
@media (min-width: 768px) {
  .form-row {
    flex-wrap: nowrap;
  }
  
  /* Campos que devem ocupar 1/3 da linha */
  .form-group.size-4 {
    flex: 0 0 calc(33.333% - 10px);
  }
  
  /* Campos que devem ocupar 2/3 da linha */
  .form-group.size-8 {
    flex: 0 0 calc(66.666% - 10px);
  }
  
  /* Campos de endereço em 3 colunas */
  .address-row .form-group {
    flex: 0 0 calc(33.333% - 10px);
  }
}

/* Estilo para campos desabilitados */
.disabled-field {
  background-color: #f5f5f5;
  color: #666;
  cursor: not-allowed;
}

.coupon-toast {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #FF6B00; /* Laranja */
  color: white;
  padding: 15px 30px;
  border-radius: 25px; /* Cantos arredondados */
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  text-align: center;
  opacity: 0;
  transition: all 0.3s ease;
  max-width: 80%;
}

.coupon-toast.show {
  opacity: 1;
  animation: slideIn 0.3s ease-out;
}

.coupon-toast.hide {
  opacity: 0;
  animation: slideOut 0.3s ease-in;
}

@keyframes slideIn {
  from {
    transform: translate(-50%, -100%);
    opacity: 0;
  }
  to {
    transform: translate(-50%, -50%);
    opacity: 1;
  }
}

@keyframes slideOut {
  from {
    transform: translate(-50%, -50%);
    opacity: 1;
  }
  to {
    transform: translate(-50%, -100%);
    opacity: 0;
  }
}

.payment-methods {
  display: flex;
  gap: 15px;
  margin-bottom: 20px;
}

.payment-method {
  flex: 1;
  padding: 8px;
  border: 2px solid #ddd;
  border-radius: 30px;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s;
}

.payment-method.active {
  border-color: #E4A64E;
  background-color: #E4A64E;
  color: white;
}

.payment-method:hover {
  border-color: #E4A64E;
}

.coupon-input {
  display: flex;
  gap: 10px;
  align-items: end;
}

.coupon-input .form-group {
  flex: 1;
}

.btn {
  padding: 12px 24px;
  border: none;
  border-radius: 30px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.3s;
}

.btn-primary {
  background-color: #E4A64E;
  color: white;
}

.btn-primary:hover {
  background-color: #d6963e;
}

.btn-secondary {
  background-color: #6c757d;
  color: white;
}

.btn-secondary:hover {
  background-color: #5a6268;
}

.btn-outline {
  background-color: transparent;
  border: 1px solid #E4A64E;
  color: #E4A64E;
}

.btn-outline:hover {
  background-color: #E4A64E;
  color: white;
}

.finalize-btn {
  width: 100%;
  padding: 15px;
  font-size: 16px;
  margin-top: 20px;
}

.boleto-display, .pix-display {
  background: white;
  border-radius: 12px;
  padding: 24px;
  margin-top: 20px;
  text-align: center;
}

.boleto-header {
  border-bottom: 2px solid #333;
  padding-bottom: 10px;
  margin-bottom: 20px;
}

.boleto-info {
  text-align: left;
  margin: 20px 0;
}

.boleto-barcode {
  font-family: 'Courier New', monospace;
  font-size: 12px;
  letter-spacing: 1px;
  background-color: #f8f9fa;
  padding: 10px;
  border-radius: 4px;
  margin: 20px 0;
}

.qr-code {
  margin: 20px 0;
}

.pix-code {
  background-color: #f8f9fa;
  padding: 15px;
  border-radius: 8px;
  font-family: 'Courier New', monospace;
  font-size: 12px;
  word-break: break-all;
  margin: 20px 0;
}

.copy-btn {
  margin-top: 10px;
}

@media (max-width: 768px) {
  .form-row, .payment-methods {
    flex-direction: column;
  }
  
  .payment-method {
    width: 100%;
  }
}

@media (max-width: 768px) {
  .wizard {
    display: flex;
    flex-wrap: nowrap; /* Impede que os itens quebrem para nova linha */
    overflow-x: auto; /* Permite rolagem horizontal se necessário */
    gap: 5px; /* Espaço entre os steps */
    padding-bottom: 10px; 
  }

  .wizard::before {
    display: none;
  }

  .step {
    flex: 0 0 auto; /* Não permite que os itens cresçam ou encolham */
    width: 30%; /* Largura aproximada para 3 itens */
    min-width: 120px; /* Largura mínima para cada step */
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 5px;
  }

  .step-number {
    width: 30px;
    height: 30px;
    font-size: 14px;
    margin-bottom: 5px;
  }

  .step-info {
    text-align: center;
    padding: 0;

  }

  .step-title {
    font-size: 12px;
    margin-bottom: 2px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
  }
  
  .step-description {
    font-size: 10px;
    display: none; 
  }

  .wizard::-webkit-scrollbar {
    display: none;
  }
  
  .wizard {
    -ms-overflow-style: none;
    scrollbar-width: none;
  }

  .plans-container {
    flex-direction: column;
  }

  .plan-card {
    max-width: 100%;
  }

  .whatsapp-chat {
    width: 280px;
    right: 10px;
  }
  
  .whatsapp-button {
    bottom: 20px;
    right: 20px;
    width: 50px;
    height: 50px;
  }
  
  .whatsapp-button i {
    font-size: 25px;
  }

  .back-button-top {
    position: static;
    text-align: right;
    margin-bottom: 15px;
    padding-right: 15px;
  }

  /* Estilo padrão (mobile-first) - campos em 100% */
.form-group-responsive {
  width: 100%;
}

/* Em desktop - campos com proporções 8 e 4 */
@media (min-width: 768px) {
  .form-group-size-4 {
    flex: 0 0 calc(33.333% - 10px) !important;
    max-width: calc(33.333% - 10px) !important;
  }

  .form-group-size-8 {
    flex: 0 0 calc(66.666% - 10px) !important;
    max-width: calc(66.666% - 10px) !important;
  }
}



}
</style>